export const PID_SORT_CODE_MESSAGE = 'Sort code must be exactly 6 digits, with no spaces or hyphens.'
export const PID_ACCOUNT_NUMBER_MESSAGE = 'Account number must be exactly 8 digits, with no spaces or hyphens.'

function exactDigits(value, length) {
  if (value === '' || value === null || value === undefined) return true
  return new RegExp(`^\\d{${length}}$`).test(String(value))
}

export const pidSortCode = ({ value }) => exactDigits(value, 6)
export const pidBankAccountNumber = ({ value }) => exactDigits(value, 8)

export const pidSortCodeValidation = {
  validation: 'required|pidSortCode',
  validationRules: { pidSortCode },
  validationMessages: {
    pidSortCode: PID_SORT_CODE_MESSAGE,
  },
  validationVisibility: 'live',
  inputmode: 'numeric',
  maxlength: 6,
  pattern: '\\d{6}',
}

export const pidBankAccountNumberValidation = {
  validation: 'required|pidBankAccountNumber',
  validationRules: { pidBankAccountNumber },
  validationMessages: {
    pidBankAccountNumber: PID_ACCOUNT_NUMBER_MESSAGE,
  },
  validationVisibility: 'live',
  inputmode: 'numeric',
  maxlength: 8,
  pattern: '\\d{8}',
}
